import type { SiteVideo } from "@/lib/site-videos";

/**
 * The video of Tom talking to camera, which is the intended hero of `/for-business-owners`.
 *
 * ────────────────────────────────────────────────────────────────────────────────
 *  TOM: TO PUT A VIDEO LIVE, DROP THE FILE IN `public/video/` AND SET `src` BELOW.
 *  A poster frame is optional but worth it: without one the player shows a black
 *  rectangle until it loads, which on a slow phone is most of the first impression.
 *  Everything else, layout included, is already built around it.
 * ────────────────────────────────────────────────────────────────────────────────
 *
 * WHY `null` SHIPS A DIFFERENT PAGE RATHER THAN AN EMPTY BOX. The page is built
 * video-first, but a "video coming soon" panel is a dead element shown to every
 * stranger who arrives, and this page exists precisely because the last one felt dead.
 * So with no video the hero renders its own complete composition and nothing looks
 * missing, and the moment `src` is set the video takes the hero and the static version
 * steps aside. Neither state is a placeholder for the other.
 *
 * FORMAT, learned the hard way elsewhere: H.264 in an .mp4 plays everywhere including
 * older iOS. Keep it under about 20MB or the first frame costs a phone user real money
 * and real seconds. It must be muted to autoplay on iOS at all, and it carries
 * `playsInline` so Safari does not take the video fullscreen the moment it starts.
 */

/** The welcome video is an ordinary {@link SiteVideo}; the name is kept because that is what
 * this one video is. See `site-videos.ts` for the field meanings and the encoding notes. */
export type FounderVideo = SiteVideo;

export const FOUNDER_VIDEO: FounderVideo | null = null;

/*
 * When the file is ready, replace the line above with something like:
 *
 * export const FOUNDER_VIDEO: FounderVideo | null = {
 *   src: "/video/tom-intro.mp4",
 *   poster: "/video/tom-intro-poster.jpg",
 *   length: "2 min",
 *   description:
 *     "Tom explaining what Ownly builds for business owners and how the first conversation works.",
 * };
 */
